import { InstructionValidationType } from './instruction-validation-type';

export const INSTRUCTION_VALIDATION_MAP: {
  key: InstructionValidationType;
  text: string;
  hasMinMax?: boolean;
}[] = [
  { key: InstructionValidationType.WholeNumber, text: 'noe.wholeNumber' },
  {
    key: InstructionValidationType.WholeNumberMinMax,
    text: 'noe.wholeNumberMinMax',
    hasMinMax: true
  },
  {
    key: InstructionValidationType.OneDecimalMinMax,
    text: 'noe.oneDecimalMinMax',
    hasMinMax: true
  },
  {
    key: InstructionValidationType.TwoDecimalMinMax,
    text: 'noe.twoDecimalMinMax',
    hasMinMax: true
  },
  { key: InstructionValidationType.OneDecimal, text: 'noe.oneDecimal' },
  { key: InstructionValidationType.TwoDecimal, text: 'noe.twoDecimal' }
];
